import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const HelpCenterIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.859375 2.36368C0.859375 2.03639 0.98939 1.72251 1.22082 1.49108C1.45225 1.25965 1.76613 1.12964 2.09342 1.12964H4.5615C4.88879 1.12964 5.20268 1.25965 5.4341 1.49108C5.66553 1.72251 5.79555 2.03639 5.79555 2.36368V19.6403C5.79555 19.9676 5.66553 20.2815 5.4341 20.5129C5.20268 20.7443 4.88879 20.8743 4.5615 20.8743H2.09342C1.76613 20.8743 1.45225 20.7443 1.22082 20.5129C0.98939 20.2815 0.859375 19.9676 0.859375 19.6403V2.36368Z"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.7959 2.36368C5.7959 2.03639 5.92591 1.72251 6.15734 1.49108C6.38877 1.25965 6.70265 1.12964 7.02994 1.12964H9.49803C9.82532 1.12964 10.1392 1.25965 10.3706 1.49108C10.6021 1.72251 10.7321 2.03639 10.7321 2.36368V19.6403C10.7321 19.9676 10.6021 20.2815 10.3706 20.5129C10.1392 20.7443 9.82532 20.8743 9.49803 20.8743H7.02994C6.70265 20.8743 6.38877 20.7443 6.15734 20.5129C5.92591 20.2815 5.7959 19.9676 5.7959 19.6403V2.36368Z"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.859375 6.06592H5.79555"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.7959 15.9382H10.7321"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.723 1.82063L14.4181 1.16658C15.1117 0.999987 15.8163 1.40105 16.0002 2.0699L20.56 18.6283C20.6404 18.9314 20.6048 19.2537 20.4601 19.5319C20.3154 19.8102 20.072 20.0244 19.7776 20.1326L19.6135 20.1832L16.9183 20.8372C16.2248 21.0038 15.5201 20.6028 15.3363 19.9339L10.7765 3.37552C10.696 3.07238 10.7317 2.75012 10.8764 2.47187C11.0211 2.19362 11.2645 1.97942 11.5589 1.87122L11.723 1.82063Z"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9658 7.29996L16.902 6.06592"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4336 15.9381L19.2747 14.7288"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
